if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
/*
document.addEventListener("DOMContentLoaded", function() {
    var selectedLang = document.documentElement.lang; // Obtener el idioma seleccionado del atributo lang del elemento html
    var mainLinks = document.querySelectorAll('main a[href^="/"]');

    mainLinks.forEach(function(link) {
      var href = link.getAttribute('href');
      var langRegEx = /^\/[a-z]{2}(-[A-Z]{2})?\//; // Expresión regular para coincidir con el formato de /xx/ o /xx-XX/
      var match = langRegEx.exec(href);
      if (!match) { // Si el enlace no tiene un idioma, agregamos el seleccionado
        if (selectedLang !== "en") { // Si el idioma seleccionado no es "en", agregamos el idioma al principio del enlace
          href = '/' + selectedLang + href;
          link.setAttribute('href', href);
        }
      } else {
        var langCode = match[0].replace(/\//g, ''); // Eliminar barras del principio y del final
        if (langCode !== selectedLang && selectedLang !== "en") { // Si el idioma del enlace no coincide con el idioma seleccionado y el idioma seleccionado no es "en"
          if (selectedLang === "pt-PT") { // Si el idioma seleccionado es "pt-PT", reemplazarlo con "pt"
            selectedLang = "pt";
          }
          href = href.replace(langRegEx, '/' + selectedLang + '/');
          link.setAttribute('href', href);
        }
      }
    });
});
*/

